// extracted by mini-css-extract-plugin
module.exports = {"morePhotoOverlay":"styles__morePhotoOverlay--3heYK","container":"styles__container--E99vc"};